<template>
  <v-container fill-height class="errors-wrapper">
    <v-row align="center" justify="center">
      <v-col>
        <div class="d-flex flex-column align-center justify-center h-100">
          <h1>500</h1>
          <h3 class="title font-weight-regular mt-8">
            {{ $t('errors.500ErrorMessage') }}
          </h3>
          <div class="mt-3 grey--text text--darken-1">
            {{ $t('errors.500ErrorDescription') }}
          </div>
          <v-btn
            class="text-none mt-5"
            color="primary"
            depressed
            :to="{
              path: '/'
            }"
            >{{ $t('errors.500ErrorButton') }}</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {}
</script>
